import { Dispatch, MouseEventHandler, SetStateAction } from 'react';

export function handleFiltersButtonClick(
	isOpen: boolean,
	setIsOpen: Dispatch<SetStateAction<boolean>>
): MouseEventHandler<HTMLButtonElement> {
	return () => {
		setIsOpen(!isOpen);
	};
}

export function handleInputTextClearClick(
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onChange: (...event: any[]) => void,
	onClear?: () => void
): MouseEventHandler<HTMLButtonElement> {
	return function () {
		onChange('');

		if (onClear) {
			onClear();
		}
	};
}
